export const errorHandler = (message:string) => {
    throw new Error(message);
}